import React from 'react'
import { FormattedMessage } from 'react-intl'
import Markdown from 'markdown-to-jsx'
import { Button, If, Unless } from 'src/Components'

import styles from './CompanyDisclaimer.module.scss'

const CompanyDisclaimer = ({ disclaimer, show, setShow }) => (
  <div className='disclaimer'>
    <If condition={show}>
      <Markdown className='disclaimer-body'>{disclaimer}</Markdown>
    </If>
    <Unless condition={show}>
      <p>
        <Button
          minimal
          onClick={() => setShow(true)}
          className={styles.disclaimerLink}
        >
          <FormattedMessage
            id='Footer.companyDisclaimer.showLink'
            defaultMessage='Read our full disclaimer'
          />
        </Button>
      </p>
    </Unless>
  </div>
)

export default CompanyDisclaimer
